import * as React from "react";

import {
  Card,
  FormControl,
  Box,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import CustomSnackbar from "../../utils/CustomSnackbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import useDetails from "src/hooks/useDetails";
import { useState } from "react";

const AddVitals = () => {
  const userDetails = useDetails();
  let p_id = userDetails?.pp_id;
  const [device_id, setDeviceId] = useState("");
  const [device_name, setDeviceName] = useState("");
  const [date_of_joining, setDoj] = useState(new Date());
  const [heart_rate, setHeartRate] = useState("");
  const [bp, setBp] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [temperature, setTemperature] = useState("");
  const [spo2, setSpo2] = useState("");
  const [variability, setVariability] = useState("");
  const [place, setPlace] = useState("");
  const [hei, setHei] = useState("cms");
  const [wei, setWei] = useState("lbs");
  const [tem, setTem] = useState("F");

  function handleSave(event, patient_id) {
    // event.preventDefault();
    axios
      .post(`${process.env.REACT_APP_KAIZEN_API}/api/dev3/insertpatientvital`, {
        patient_id: p_id,
        device_id: device_id,
        device_name: device_name,
        date_of_joining: date_of_joining,
        heart_rate: heart_rate + " bpm",
        bp: bp + " mmHg",
        height: height + " " + hei,
        weight: weight + " " + wei,
        temperature: temperature + " \u00b0" + tem,
        spo2: spo2 + " %",
        variability: variability + " ms",
        place: place,
      })
      .then((res) => {
        //console.log(res);
        console.log("");
        {
          setOpenSnack({
            open: true,
            severity: "success",
            message: "Details Saved Successfully",
            position: ["bottom", "center"],
          });
          setTimeout(() => {
            navigate("../");
            setOpenSnack({ open: false });
          }, 3000);
        }
      })
      .catch((err) => {
        //console.log(err);
        console.log("");
        {
          setOpenSnack({
            open: true,
            severity: "error",
            message: "Something went Wrong",
            position: ["bottom", "center"],
          });
          setTimeout(() => {
            // navigate("../");
            setOpenSnack({ open: false });
          }, 3000);
        }
      });
  }

  const [openSnack, setOpenSnack] = React.useState({
    open: false,
    severity: null,
    message: null,
  });

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const handleFormSubmit = async (values) => {};

  const navigate = useNavigate();
  const { open, severity, message, position } = openSnack;

  return (
    <>
      {CustomSnackbar(open, severity, message)}

      <Helmet>
        <title> Add Vitals | Kaizen Digital </title>
      </Helmet>
      <Card>
        <Box m="20px">
          <Typography variant="h3" gutterBottom color="primary">
            Add My Vitals
          </Typography>
          <br />
          <br />
          <Card>
            <Box m="20px">
              <Formik
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={checkoutSchema}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box
                      display="grid"
                      gap="30px"
                      gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                      sx={{
                        "& > div": {
                          gridColumn: isNonMobile ? undefined : "span 4",
                        },
                      }}
                    >
                      <TextField
                        type="text"
                        label="Enter Device ID"
                        onBlur={handleBlur}
                        onChange={(e) => setDeviceId(e.target.value)}
                        value={device_id}
                        name=""
                        sx={{ gridColumn: "span 1" }}
                      />

                      <TextField
                        type="text"
                        label="Device Name"
                        onBlur={handleBlur}
                        onChange={(e) => setDeviceName(e.target.value)}
                        value={device_name}
                        name=""
                        sx={{ gridColumn: "span 1" }}
                      />

                      <TextField
                        type="text"
                        label="Heart Rate / Pulse Rate (beats per minute)"
                        onBlur={handleBlur}
                        onChange={(e) => setHeartRate(e.target.value)}
                        value={heart_rate}
                        name=""
                        sx={{ gridColumn: "span 1" }}
                      />

                      <TextField
                        type="text"
                        label="Blood Pressure (mmHg)"
                        onBlur={handleBlur}
                        onChange={(e) => setBp(e.target.value)}
                        value={bp}
                        name=""
                        sx={{ gridColumn: "span 1" }}
                      />
                      <div style={{ minWidth: "25%" }}>
                        <TextField
                          type="text"
                          label="Weight"
                          onBlur={handleBlur}
                          onChange={(e) => setWeight(e.target.value)}
                          value={weight}
                          name="weight"
                          sx={{ gridColumn: "span 1" }}
                        />
                        <Select
                          labelId="wei"
                          id="wei"
                          name="wei"
                          label="Select Units"
                          value={wei}
                          onBlur={handleBlur}
                          onChange={(e) => setWei(e.target.value)}
                          sx={{ gridColumn: "span 1" }}
                        >
                          <MenuItem value={"lbs"}>lbs</MenuItem>
                          <MenuItem value={"kgs"}>kgs</MenuItem>
                        </Select>
                      </div>
                      <div style={{ minWidth: "25%" }}>
                        <TextField
                          type="text"
                          label="Height"
                          onBlur={handleBlur}
                          onChange={(e) => setHeight(e.target.value)}
                          value={height}
                          name="height"
                          sx={{ gridColumn: "span 1" }}
                        />
                        <Select
                          labelId="hei"
                          id="hei"
                          label="Select Units"
                          name="hei"
                          value={hei}
                          onBlur={handleBlur}
                          onChange={(e) => setHei(e.target.value)}
                          sx={{ gridColumn: "span 1" }}
                        >
                          <MenuItem value={"cms"}>cms</MenuItem>
                          <MenuItem value={"feet/inches"}>ft/in</MenuItem>
                        </Select>
                      </div>
                      <div style={{ minWidth: "25%" }}>
                        <TextField
                          type="text"
                          label="Temperature"
                          onBlur={handleBlur}
                          onChange={(e) => {
                            setTemperature(e.target.value);
                          }}
                          value={temperature}
                          name=""
                          sx={{ gridColumn: "span 1" }}
                        />
                        <Select
                          labelId="tem"
                          id="tem"
                          name="tem"
                          label="Select Units"
                          value={tem}
                          onBlur={handleBlur}
                          onChange={(e) => setTem(e.target.value)}
                          sx={{ gridColumn: "span 1" }}
                        >
                          <MenuItem value={"F"}>F</MenuItem>
                          <MenuItem value={"C"}>C</MenuItem>
                        </Select>
                      </div>

                      <TextField
                        type="text"
                        label="sp02 (%)"
                        onBlur={handleBlur}
                        onChange={(e) => setSpo2(e.target.value)}
                        value={spo2}
                        name=""
                        sx={{ gridColumn: "span 1" }}
                      />
                      <TextField
                        type="text"
                        label="Heart Rate Variability (ms)"
                        onBlur={handleBlur}
                        onChange={(e) => setVariability(e.target.value)}
                        value={variability}
                        name=""
                        sx={{ gridColumn: "span 1" }}
                      />

                      <FormControl
                        sx={{
                          gridColumn: "span 1",
                        }}
                      >
                        <InputLabel id="place">Place</InputLabel>
                        <Select
                          labelId="place"
                          id="place"
                          name="place"
                          label="place"
                          value={place}
                          onBlur={handleBlur}
                          onChange={(e) => setPlace(e.target.value)}
                        >
                          <MenuItem value={"Home"}>Home</MenuItem>
                          <MenuItem value={"KBC Clinic"}>KBC Clinic</MenuItem>
                          <MenuItem value={"Other"}>Other</MenuItem>
                        </Select>
                      </FormControl>
                      <br />

                      <Box display="flex" justifyContent="end">
                        <Button
                          onClick={handleSave}
                          type="submit"
                          variant="contained"
                          sx={{ color: "white" }}
                        >
                          SAVE VITAL DETAILS
                        </Button>
                      </Box>
                      <br />
                      <br />
                    </Box>
                  </form>
                )}
              </Formik>
            </Box>
          </Card>
        </Box>
      </Card>
    </>
  );
};

const checkoutSchema = yup.object().shape({});
const initialValues = {};

export default AddVitals;
